import { render } from "./RoomCard_Pop.vue?vue&type=template&id=6470762d&scoped=true&lang=pug"
import script from "./RoomCard_Pop.vue?vue&type=script&lang=js"
export * from "./RoomCard_Pop.vue?vue&type=script&lang=js"

import "./RoomCard_Pop.vue?vue&type=style&index=0&id=6470762d&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/cschool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6470762d"]])

export default __exports__